module.exports = __webpack_public_path__ + "img/zm.49d0d57a.svg";